<footer>
  <div class="info">
    <div>
      <img src="./assets/logo-sped.jpg" class="logo">
    </div>
    <div class="align-top">
        <h2>Escritório</h2>
        <p><i class="fa fa-phone"></i>+55 (32) 3212-4324</p>
        <p><i class="far fa-envelope"></i> <a href="mailto:contato@e-auditoria.com.br">contato@e-auditoria.com.br</a></p>
        <p><i class="far fa-envelope"></i> <a href="mailto:financeiro@e-auditoria.com.br">financeiro@e-auditoria.com.br</a></p>
        <p class="address"><span class="icon"></span>Rua Doutor Constantino Paleta, 179, Centro.
            <br/>&nbsp;&nbsp;&nbsp;&nbsp; Juiz de Fora - MG CEP: 36015-450
        </p>
      </div>
    <div class="align-top">
      <h2>Suporte Técnico</h2>
      <p><i class="far fa-file-pdf"></i> <a [href]="urlBlobPdf" target="_blank">FAQ - Perguntas Frequentes</a></p>
      <p><i class="far fa-envelope"></i> <a href="mailto:suporte@spedautomation.com.br"> suporte@spedautomation.com.br</a>
      </p>
      <p><i class="far fa-clock"></i> De seg. a sex. das 9h00 às 17h30</p>
      <p><br/></p>
      <p><br/></p>
    </div>
    <div>
        <ul>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/spedautomation"><i
                    class="fab fa-instagram"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/spedautomation"><i
                    class="fab fa-facebook"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/spedautomation"><i
                    class="fab fa-linkedin"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCWJJYO1w_qbTy-RsCki4A9Q"><i
                    class="fab fa-youtube"></i></a>
            </li>
        </ul>
    </div>
  </div>
  <div class="copyright">
    <p>
        <a target="_blank" rel="noopener noreferrer" href="https://www.spedautomation.com.br/" target="_blank">
            © {{ today.getFullYear() }} uma solução SPED Automation
        </a>
    </p>
  </div>
</footer>